export default "__VITE_ASSET__CP_FNZgD__"